module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_library.js
// module id = 45
// module chunks = 1